/**
 * Langues supportées par l'application
 */
export const SUPPORTED_LANGUAGES = ['fr'] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * Langue par défaut
 */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

/**
 * Langues disponibles pour les contenus (clé => valeur)
 * Format: { code: 'nom de la langue' }
 */
export const CONTENT_LANGUAGES: Record<string, string> = {
  fr: 'Français',
  en: 'Anglais',
  de: 'Allemand',
  es: 'Espagnol',
  it: 'Italien',
  nl: 'Néerlandais',
  pt: 'Portugais',
} as const;

/** Code langue de contenu (défini par museum.langs, pas limité au catalogue ci-dessus) */
export type ContentLanguageCode = string;

/**
 * Catalogue historique des couleurs d'exposition (codes legacy).
 * Les nouveaux musées peuvent aussi utiliser des hex directement dans availableExhibitionColors.
 * Format: { code: { name: 'nom français', hex: '#code couleur' } }
 */
export const EXHIBITION_COLORS = {
  default: { name: 'À définir', hex: '#E5E5E5' },
  brown: { name: 'Marron', hex: '#9D412D' },
  blue: { name: 'Bleu', hex: '#3D7195' },
  petrol: { name: 'Bleu pétrole', hex: '#386063' },
  burgundy: { name: 'Bordeaux', hex: '#831a14' },
} as const;

export type ExhibitionColorCode = keyof typeof EXHIBITION_COLORS;

/**
 * Rôles utilisateur
 */
export const USER_ROLES = {
  ADMIN: 'admin',
  EDITOR: 'editor',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

/** Format et taille max pour l'upload audio (audioguide : épisodes ~2–20 min, MP3 128–192 kbps) */
export const AUDIO_UPLOAD = {
  ACCEPT: 'audio/mpeg,audio/mp3,.mp3',
  MAX_SIZE_MB: 25,
  MAX_SIZE_BYTES: 25 * 1024 * 1024,
} as const;

/**
 * Collections Firestore
 */
export const FIRESTORE_COLLECTIONS = {
  MUSEUMS: 'museums',
  USERS: 'users',
  EXHIBITIONS: 'exhibitions',
  WORKS: 'works',
} as const;

